import { createSlice } from '@reduxjs/toolkit'
import { advisorInitialState } from '../initialState/advisor'
import {
  fetchAdvisorsThunk,
  createAdvisorThunk,
  cloneAdvisorThunk,
} from '../asyncThunks/advisor'
import { AdvisorState } from '../types/advisor'

const advisorSlice = createSlice({
  name: 'advisor',
  initialState: advisorInitialState as AdvisorState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvisorsThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAdvisorsThunk.fulfilled, (state, action) => {
        state.loading = false
        state.advisors = action.payload
      })
      .addCase(fetchAdvisorsThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(createAdvisorThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(createAdvisorThunk.fulfilled, (state, action) => {
        state.loading = false
        if (Array.isArray(state.advisors)) {
          state.advisors.push(action.payload)
        } else {
          state.advisors = [action.payload]
        }
      })
      .addCase(createAdvisorThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(cloneAdvisorThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(cloneAdvisorThunk.fulfilled, (state, action) => {
        state.loading = false
        if (Array.isArray(state.advisors)) {
          state.advisors.push(action.payload)
        } else {
          state.advisors = [action.payload]
        }
      })
      .addCase(cloneAdvisorThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default advisorSlice.reducer
